// extracted by mini-css-extract-plugin
export default {"root":"P8EJjCE9Dp8b2orcuMis"};